module.exports = __webpack_public_path__ + "img/bandicam_00002.1da93df5.png";